import { c as _c } from "react/compiler-runtime";
import { ThirdPartyScriptWrapper } from './ThirdPartyScriptWrapper';
export const MarketoForms2 = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ThirdPartyScriptWrapper id="marketo-forms2" scriptContent="" ignoreInDevelopment={false} scriptOptions={{
      src: "https://learn.lokalise.com/js/forms2/js/forms2.min.js",
      defer: true,
      strategy: "lazyOnload"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};